import React, { useState } from "react";
import { FaPlus } from "react-icons/fa";
import { TiDelete } from "react-icons/ti";
import { CustomTab, CustomTabs } from "components/tabs/Tabs";
import { planDetailApi, updatePlanApi } from "services/plan";
import useButtonLoader from "common/UseButtonLoader";
import { Input } from "common/InputForm";
import { toastMessage } from "utils/toastMessage";
import useFullPageLoader from "common/UseFullPageLoader";
import CustomButton from "components/form";
import { Link } from "react-router-dom";
import "./PlanManagement.scss";
import { IoMdArrowRoundBack } from "react-icons/io";
const PlanManagement = () => {
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Update");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [type, setType] = useState("free");
  const [planData, setPlanData] = useState({
    planId: "",
    title: "",
    description: "",
    duration: "",
    price: "",
    razorPayPlanId: "",
    benefits: [],
  });
  const [errorField, setErrorField] = useState({
    title: "",
    description: "",
    duration: "",
    price: "",
    razorPayPlanId: "",
    benefits: [],
  });
  const validateBenefits = () => {
    const errorsBenefits = [];
    planData?.benefits?.forEach((benefit, index) => {
      if (!benefit) {
        errorsBenefits[index] = "Benefit is required";
      }
    });
    return errorsBenefits;
  };
  const handleValidation = () => {
    let errorMessage = {};
    let status = true;
    if (!planData.title) {
      errorMessage["title"] = "Please enter title";
      status = false;
    }

    if (!planData.price) {
      errorMessage["price"] = "Please enter price";
      status = false;
    }
    if (!planData.duration) {
      errorMessage["duration"] = "Please enter duration";
      status = false;
    }
    if (!planData.discountPrice) {
      errorMessage["discountPrice"] = "Please enter discount Price";
      status = false;
    }

    if (!planData.razorPayPlanId) {
      errorMessage["razorPayPlanId"] = "Please enter inAppPurchase Id";
      status = false;
    }

    if (!planData.description) {
      errorMessage["description"] = "Please enter description";
      status = false;
    }

    const errorsBenefits = validateBenefits();
    if (errorsBenefits.length > 0) {
      errorMessage.benefits = errorsBenefits;
    }

    setErrorField(errorMessage);
    return status;
  };
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setPlanData({ ...planData, [name]: value });
    setErrorField((prevErrors) => ({
      ...prevErrors,
      [name]: null,
    }));
  };
  // xds
  const editPlanHandler = async (e) => {
    e.preventDefault();
    if (handleValidation(e)) {
      try {
        setButtonLoaders(true);
        const finalData = {
          title: planData.title,
          duration: planData.duration,
          planId: planData.planId,
          price: planData.price,
          discountPrice: planData.discountPrice,
          razorPayPlanId: planData.razorPayPlanId,
          benefits: planData.benefits,
          description: planData.description,
        };
        const res = await updatePlanApi(finalData);
        if (res.data.status === 200) {
          toastMessage(res.data.message, "success", "updatePlan");
        } else {
          toastMessage(res.data.message, "error", "updatePlan");
        }
      } catch (error) {
        console.log("error:", error.error);
      } finally {
        setButtonLoaders(false);
      }
    }
  };
  // plan details api*
  const getPlanDetailes = async () => {
    try {
      showLoader();
      const res = await planDetailApi();
      console.log("🌹 ~ file: EditFaq.jsx:98 ~ getPlanDetailes ~ res:", res);
      if (res.data?.status === 200) {
        setPlanData({
          title: res?.data?.data?.title,
          duration: res?.data?.data?.duration,
          planId: res?.data?.data?._id,
          benefits: res?.data?.data?.benefits || [],
          discountPrice: res?.data?.data?.discountPrice,
          price: res?.data?.data?.price,
          razorPayPlanId: res?.data?.data?.razorPayPlanId,
          description: res?.data?.data?.description,
        });
      } else {
        toastMessage(res.data.message, "error", "updatePlan");
      }
    } catch (err) {
      console.log("error:", err.error);
    } finally {
      hideLoader();
    }
  };
  React.useEffect(() => {
    getPlanDetailes();
  }, [type]);
  const handleBenefitsChange = (e, index) => {
    const newBenefits = [...planData?.benefits];
    newBenefits[index] = e.target.value;
    setPlanData({
      ...planData,
      benefits: newBenefits,
    });
    setErrorField((prevErrors) => ({
      ...prevErrors,
      benefits: null,
    }));
  };
  const handleAddBenefit = () => {
    setPlanData({
      ...planData,
      benefits: [...planData.benefits, ""],
    });
  };
  const handleRemoveBenefit = (index) => {
    const newBenefits = [...planData.benefits];
    newBenefits.splice(index, 1);
    setPlanData({
      ...planData,
      benefits: newBenefits,
    });
  };
  return (
    <div className="addClass">
      <div className="dashboard_title has_child">
        <h3>
          <Link to={-1}></Link> Plan Management
        </h3>
        <CustomButton
          type="button"
          className="button"
          ref={buttonLoaders}
          onClick={editPlanHandler}
        >
          Edit
        </CustomButton>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="form_field_wrap">
              <div className="form_field">
                <Input
                  type="text"
                  name="title"
                  label="Title"
                  value={planData?.title}
                  placeholder="Enter title"
                  onChange={onChangeHandler}
                />
                {errorField.title && (
                  <span className="text-danger">{errorField.title}</span>
                )}
              </div>
              <div className="form_field">
                <div className="form_field col-6">
                  <label className="form-label">Duration</label>
                  <select
                    className={`form-select ${
                      errorField.duration ? "is-invalid" : ""
                    }`}
                    class="input form-control"
                    id="number"
                    name="duration"
                    value={planData.duration}
                    onChange={onChangeHandler}
                  >
                    <option value=""> Select Duration</option>
                    <option value={"1"}>1 Month</option>
                    {/* <option value={"2"}>2 Month</option> */}
                    <option value={"3"}>3 Months</option>
                    {/* <option value={"4"}>4 Month</option>
                    <option value={"5"}>5 Month</option> */}
                    <option value={"6"}>6 Months</option>
                    {/* <option value={"7"}>7 Month</option>
                    <option value={"8"}>8 Month</option>
                    <option value={"9"}>9 Month</option>
                    <option value={"10"}>10 Month</option>
                    <option value={"11"}>11 Month</option> */}
                    <option value={"12"}>12 Months</option>
                  </select>
                  {errorField.duration && (
                    <span className="text-danger">{errorField.duration}</span>
                  )}
                </div>
              </div>

              <div className="form_field">
                <Input
                  type="text"
                  name="price"
                  label="Price"
                  value={planData?.price}
                  placeholder="Enter  Price"
                  onChange={(e) => {
                    const inputText = e.target.value;
                    const sanitizedText = inputText.replace(/[^0-9]/g, "");
                    const maxLength = 10;
                    const truncatedText = sanitizedText.slice(0, maxLength);
                    e.target.value = truncatedText;
                    onChangeHandler(e);
                  }}
                />
                {errorField.price && (
                  <span className="text-danger">{errorField.price}</span>
                )}
              </div>
            </div>

            <div className="form_field">
              <Input
                type="string"
                name="razorPayPlanId"
                label="RazorPay PlanId"
                value={planData?.razorPayPlanId}
                placeholder="Enter PurchaseId"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              />
              {errorField.razorPayPlanId && (
                <span className="text-danger">{errorField.razorPayPlanId}</span>
              )}
            </div>
            <div className="form_field">
              <Input
                type="text"
                name="description"
                label="Description"
                value={planData?.description}
                placeholder="Enter Description"
                onChange={(e) => {
                  onChangeHandler(e);
                }}
              />
              {errorField.description && !planData?.description && (
                <span className="text-danger">{errorField?.description}</span>
              )}
            </div>

            <label className="label form-label">Benefits</label>
            {planData?.benefits?.map((benefit, index) => (
              <div key={index} className="form_field ">
                <div className="benefit-input  w-100">
                  <Input
                    className="input form-control"
                    type="text"
                    value={benefit}
                    onChange={(e) => handleBenefitsChange(e, index)}
                  />
                  {errorField.benefits && errorField.benefits[index] && (
                    <span className="text-danger">
                      {errorField.benefits[index]}
                    </span>
                  )}

                  <span className="delete_button">
                    <TiDelete
                      className="fs-3"
                      onClick={() => handleRemoveBenefit(index)}
                    />
                  </span>
                </div>
              </div>
            ))}

            <div className="button_wrap button_right w-100">
              <button
                type="button"
                className="button cstm_btn"
                onClick={handleAddBenefit}
              >
                <FaPlus /> Add Benefit
              </button>
            </div>
            {/* </div>
              </div> */}
          </form>
        </div>
      </div>
    </div>
  );
};

export default PlanManagement;
